import {AfterViewInit, Component, Input, OnDestroy, OnInit} from '@angular/core';
import { WorkflowStepHistoryDto } from 'app/models/workflow/workflow-instance.interface';
import { WorkflowService } from 'app/services/workflow.service';
import {Observable, Subscription} from 'rxjs';

@Component({
  selector: 'app-workflow-history',
  templateUrl: 'workflow-history.component.html',
  styleUrls: ['workflow-history.component.scss'],
})

export class WorkflowHistoryComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input()
  workflowInstanceId: number;
  workflowHistory$: Observable<WorkflowStepHistoryDto[]>;

  @Input() onContinueObservable: Observable<void>;
  private onContinueSuscription: Subscription;

  constructor(
    private workflowService: WorkflowService,
  ) {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.workflowHistory$ = this.workflowService.getHistory(this.workflowInstanceId);

    this.onContinueSuscription = this.onContinueObservable.subscribe(() => {
      this.workflowHistory$ = this.workflowService.getHistory(this.workflowInstanceId);
    })
  }

  ngOnDestroy(): void {
    this.onContinueSuscription.unsubscribe();
  }

}
